import React, { useState } from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './components/home/Home';
import Bikes from './components/bikes/Bikes';
import Events from './components/events/Events';
import Contact from './components/contact/Contact';
import Chat from './components/shared/Chat';
import bikesData from './Data/Bikes.json';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import SuppliersPage from './components/suppliers/SuppliersPage';
import ArchivePage from './components/archive/ArchivePage';
import WikiSearchPage from './components/wiki/WikiSearchPage';
import ArticleView from './components/wiki/ArticleView';
import JampotRally from './components/rally/JampotRally';
import PartsPage from './components/parts/PartsPage';
import BookingClosed from './booking/pages/BookingClosed';
import AdminBookingsPage from './components/admin/AdminBookingsPage';
import BookingSuccess from "./components/booking-status/BookingSuccess";
import BookingCancel from "./components/booking-status/BookingCancel";
import PrivacyPolicy from "./components/policy/PrivacyPolicy";
import RestorationProjectPage from './Restoration/RestorationProjectPage';
import AdminManualsPage from './components/admin/AdminManualsPage';

function App() {
  const getPageFromHash = () => {
    const hash = window.location.hash || "";
    const hashWithoutHash = hash.startsWith("#") ? hash.slice(1) : hash;
    const [pathOnly] = hashWithoutHash.split("?");
    const page = pathOnly.replace(/^\/+/, "");
    return page || "home";
  };

  const [selectedPage, setSelectedPage] = useState(getPageFromHash());
  const [selectedArticle, setSelectedArticle] = useState(null);

  const scrollToPageTop = () => {
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
  };

  const handleNavigate = (page) => {
    setSelectedArticle(null);
    setSelectedPage(page);
    window.location.hash = `/${page}`;
    scrollToPageTop();
  };

  React.useEffect(() => {
    const onHashChange = () => {
      setSelectedArticle(null);
      setSelectedPage(getPageFromHash());
      scrollToPageTop();
    };

    window.addEventListener('hashchange', onHashChange);

    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const renderContent = () => {
    if (selectedArticle) {
      return (
        <ArticleView
          article={selectedArticle}
          onBack={() => setSelectedArticle(null)}
        />
      );
    }

    console.log(selectedPage);

    switch (selectedPage) {
      case 'home':
        return <Home onNavigate={handleNavigate} />;
      case 'jampot':
        return <JampotRally onNavigate={handleNavigate} />;
      case 'bikes':
        return <Bikes onNavigate={handleNavigate} />;
      case 'events':
        return <Events onNavigate={handleNavigate} />;
      case 'suppliers':
        return <SuppliersPage onNavigate={handleNavigate} />;
      case 'archive':
        return <ArchivePage onNavigate={handleNavigate} />;
      case 'parts':
        return <PartsPage onNavigate={handleNavigate} />;
      case 'wiki':
        return (
          <WikiSearchPage
            onNavigate={handleNavigate}
            onSelectArticle={setSelectedArticle}
          />
        );
      case 'contact':
        return <Contact onNavigate={handleNavigate} />;
      case 'booking':
        return <BookingClosed onNavigate={handleNavigate} />;
      case 'managebooking':
        return <BookingClosed onNavigate={handleNavigate} mode="manage" />;
      case 'adminbookings':
        return <AdminBookingsPage onNavigate={handleNavigate} />;
      case 'restoration':
        return <RestorationProjectPage onNavigate={handleNavigate} />;
      case 'booking-success':
        return <BookingSuccess onNavigate={handleNavigate} />;
      case 'booking-cancel':
        return <BookingCancel onNavigate={handleNavigate} />;
      case 'privacypolicy':
        return <PrivacyPolicy onNavigate={handleNavigate} />;
        case 'adminmanuals':
  return <AdminManualsPage onNavigate={handleNavigate} />;
      default:
        return <Home onNavigate={handleNavigate} />;
    }
  };

  const isBookingPage =
    selectedPage === "booking" ||
    selectedPage === "managebooking" ||
    selectedPage === "adminbookings" ||
    selectedPage === "booking-success" ||
    selectedPage === "booking-cancel" ||
  selectedPage === "adminmanuals" ||  
    selectedPage === "jampot/booking";

  return (
    <div className="App">
      {!isBookingPage && (
        <Header selectedPage={selectedPage} onNavigate={handleNavigate} />
      )}

      <div className="content">
        {renderContent()}
      </div>

      {!isBookingPage && <Footer />}

      <div
        style={{
          overflow: 'hidden',
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '0%',
          maxWidth: '400px',
          padding: '0px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          backgroundColor: 'red',
          borderRadius: '10px',
          zIndex: '1000',
          margin: '0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Chat bikes={bikesData} />
      </div>
    </div>
  );
}

export default App;
